// extracted by css-extract-rspack-plugin
export default {"pill":"fg64_","remove":"qEu0P","checkbox":"TyHZx","groupLabel":"r2WoT"};